import { useTranslation } from "next-i18next";
import { routerHandler } from "@/lib/routes/router-links-handler";
import { siteName, resolveButtonCustomIcon, resolveButtonIconColor, cn, resolveProductImage } from "@/lib/functions";
import Image from "@/components/Atoms/Image";
import { MultiPurposeTitle } from "@/components/Atoms/Title";
import { CustomUnderline, Underline } from "@/components/Atoms/Underline";
import { ButtonMaster } from "@/components/Atoms/Buttons";
import styles from "./index.module.scss";
import { ProductCardProps } from "./types";

export function ProductCard({
	entry,
	locale,
	portfolioSlug,
	data,
	buttonConfig,
	variant = "default",
	carouselImageSize = "default",
}: ProductCardProps) {
	const { t } = useTranslation();
	const isRomeira = siteName === "romeira";
	const isRelatedCarousel =
		variant === "carousel" && carouselImageSize === "related";
	const imageClassName =
		variant === "carousel"
			? isRelatedCarousel
				? `z-30 mx-auto ${styles.relatedCarouselProductImage}`
				: "max-w-[17rem] sm:max-w-[20rem] md:max-w-[26rem] lg:max-w-[28rem] z-30 mx-auto w-full"
			: "max-w-[15rem] md:max-w-[22rem] z-30 mx-auto";

	return (
		<div className="flex flex-col items-center w-full">
			<div
				className={cn(
					isRelatedCarousel
						? styles.pdpRelatedProductImage
						: "w-full flex justify-center"
				)}
			>
				<Image
					className={imageClassName}
					data={resolveProductImage(entry)}
				/>
			</div>
			<article className={`flex flex-col items-center gap-8`}>
				<div
					className={`${styles.title} ${variant === "carousel" ? styles.titleCarousel : ""} flex flex-col gap-2 items-center w-full`}
				>
					<MultiPurposeTitle
						tag="p"
						type="headline"
						data={entry.productName}
						color={data.productDetailTextColor?.color}
						layout={"center"}
						className={
							isRomeira
								? "relatedHeadlineText xl:min-h-[2lh]"
								: "xl:min-h-[2lh]"
						}
					/>
					{data.addRelatedTitleUnderline && (
						<>
							{data.customUnderlineAsset?.img ? (
								<CustomUnderline
									shape={data.customUnderlineAsset?.img}
									color={data.underlineColor?.color}
								/>
							) : (
								<Underline color={data.underlineColor?.color} />
							)}
						</>
					)}
				</div>
				<ButtonMaster
					anim={"slideLeft"}
					type={buttonConfig?.buttonStyle}
					color={buttonConfig?.labelColor?.color}
					cta={buttonConfig?.typeColor?.color}
					customIcon={resolveButtonCustomIcon(buttonConfig)}
					customColor={resolveButtonIconColor(buttonConfig)}
					link={`${routerHandler({
						typename: entry?.__typename,
						slug: [portfolioSlug, entry.productTypeSpecific?.slug, entry?.slug],
						locale: locale,
					})}`}
				>
					{t(data.relatedCtaLabel?.label)}
				</ButtonMaster>
			</article>
		</div>
	);
}
